import clsx from 'clsx';
import React from 'react';

import { ContentPreloader } from '..';

import styles from './styles';

export interface ButtonProps {
  className?: string;
  type: 'primary' | 'outline';
  size?: 'normal' | 'large';
  disabled?: boolean;
  expand?: boolean;
  loading?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const Button: React.FC<ButtonProps> = (props) => {
  return (
    <button
      className={clsx([
        props.className,
        styles.button,
        'button button-primary',
        { 'button-outline': props.type === 'outline' },
        { 'button-block': props.expand },
        { [styles.disabled]: props.disabled },
        { [styles.largeButton]: props.size === 'large' },
      ])}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      { props.loading && <ContentPreloader background="transparent" />}
      { props.loading ? '\b' : props.children}
    </button>
  );
};

export default Button;
